"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgilePointServiceClient = exports.MimeTypes = void 0;
const utils_html_1 = require("@agilepoint/utils-html");
const utils_common_1 = require("@agilepoint/utils-common");
const errorTags = {
    standard: {
        start: '<1DCED31183B04261896B23C4452276F1_AGILEPOINT>',
        end: '<AGILEPOINT_1DCED31183B04261896B23C4452276F1>'
    },
    fallback: {
        start: '<AgilePointServerException>',
        end: '</AgilePointServerException>'
    }
};
function parseError(text = '') {
    const decodedText = (0, utils_html_1.unescape)(text);
    const currentErrorTags = decodedText.includes(errorTags.standard.start) ? errorTags.standard : errorTags.fallback;
    const first = decodedText.indexOf(currentErrorTags.start) + currentErrorTags.start.length;
    const last = decodedText.lastIndexOf(currentErrorTags.end);
    if (first >= last) {
        return '';
    }
    let msg = decodedText.substr(first, last - first);
    msg = msg.replace(/([#])/, '\\#').replace(/&lt;/g, '').replace(/&gt;/g, '');
    msg = msg.replace(/\\/g, '\\\\');
    return msg;
}
exports.MimeTypes = {
    JSON: 'application/json;charset=utf-8',
    XML: 'text/xml',
    HTML: 'text/html',
    text: 'text'
};
class AgilePointServiceClient {
    constructor(options) {
        this.options = options;
    }
    get(url, headers = {}) {
        return this.fetch(url, { headers });
    }
    getJSON(url, headers = {}) {
        return this.get(url, headers).then(r => r.json());
    }
    post(url, data, headers = {}) {
        return this.fetch(url, {
            method: 'POST',
            body: data,
            headers
        });
    }
    postJSON(url, data, headers = {}) {
        return this.post(url, data ? JSON.stringify(data) : undefined, {
            'Content-Type': exports.MimeTypes.JSON,
            ...headers
        });
    }
    async fetch(url, input = {}) {
        const { credentials, headers = {}, baseUrl, getAgilePointConfiguration, sessionController } = this.options;
        const defaultHeaders = headers;
        const { culture = 'en-US' } = getAgilePointConfiguration();
        const auth = await sessionController.getAuthToken();
        const res = await fetch((0, utils_common_1.combineUrl)(baseUrl, url), {
            ...input,
            credentials,
            headers: {
                ...defaultHeaders,
                Authorization: auth,
                ...input.headers || {},
                locale: culture
            }
        });
        if (!res.ok) {
            const error = parseError(await res.text());
            throw new Error(error);
        }
        return res;
    }
}
exports.AgilePointServiceClient = AgilePointServiceClient;
//# sourceMappingURL=agilepoint-service-client.js.map